import React from 'react';
import { Advice } from '@Sage/hoi-poi-ui';

function Message({
    placeholder,
    messageType = 'info',
    showCollapse = false,
    showIcon = false,
    defaultCollapsed = false,
    title = null,
    className,
}) {
    return (
        <Advice
            className={className}
            showIcon={showIcon}
            type={messageType}
            showCollapse={showCollapse}
            defaultCollapsed={defaultCollapsed}
            title={title}
        >
            {placeholder}
        </Advice>
    );
}

export default Message;
